(function ($) {
    "use strict";

    let searchCircle; // Global variable to hold the circle

    function new_filter_map_places($el) {
        // var
        var $markers = $el.find('.marker');

        // vars
        var args = {
            zoom: 16,
            center: new google.maps.LatLng(46.83333, 17.7333304),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#212121"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#4e4e4e"
                        },
                    ]
                },
                {
                    "featureType": "road.local",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#DEDEDE"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                }
            ]
        };

        // create map
        var map = new google.maps.Map($el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        $markers.each(function () {
            add_filter_places_marker($(this), map);
        });

        var clusterStyles = [
            {
                textColor: 'white',
                url: localize.themeurl + '/assets/img/svg/cluster.svg',
                height: 30,
                width: 30
            },
        ];

        //markerClusterPlaceser
        var options = {
            styles: clusterStyles,
        };

        $.markerClusterPlaces = new MarkerClusterer(map, (map.markers).filter(e => e.category != 'gas_station'), options);

        // center map
        $.center_filter_map_places(map);

        // Close infowindows when clicking away
        google.maps.event.addListener(map, "click", function (event) {
            // $.closeAllInfoWindowPlaces();
        });

        // return
        return map;
    }

    function add_filter_places_marker($marker, map) {
        // var
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        var icon = {
            url: $marker.attr('data-icon'),
            scaledSize: new google.maps.Size(50, 50)
        };

        var iconDefafult = {
            url: $marker.attr('data-icon'),
            scaledSize: new google.maps.Size(50, 50)
        };

        var iconActive = {
            url: $marker.attr('data-iconactive'),
            scaledSize: new google.maps.Size(50, 50)
        };

        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: icon,
            iconActive: iconActive,
            iconDefafult: iconDefafult,
            category: $marker.data('category'),
            url: $marker.data('url'),
            name: $marker.data('name'),
            address: $marker.data('address'),
            image_url: $marker.data('imageurl'),
        });

        // add to array
        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            marker['infowindow'] = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function () {
                map.setCenter(this.getPosition());

                if (currentmarkerplaces != this) {
                    marker.setIcon(marker.iconActive);

                    $.closeAllInfoWindowPlaces();

                    currentinfowindowplaces = this['infowindow'];
                    currentmarkerplaces = this;

                    removeDefaultInfowindow();

                    $('.js-map-popup-content').html(`
                        <div class="popup__image pb-image-ratio">
                        <img class="img--fluid ofi-cover-center" src=${marker.image_url} alt=${marker.name}>
                        </div>

                        <div class="popup__content">
                            <h2 class="title">
                                ${marker.name}
                            </h2>

                            <div class="popup__content__buttons">
                                <a href="${marker.url}" class="button button--outline button--small-height">
                                Megnézem
                                </a>
                                <a href="https://www.google.com/maps/dir//${marker.address}" target="_blank" class="button button--outline button--small-height"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 22.5C3 23.3284 2.32843 24 1.5 24V24C0.671573 24 0 23.3284 0 22.5V9.62344C0 7.96658 1.34315 6.62344 3 6.62344H18.2531L14.8148 3.18515C14.2285 2.59878 14.2285 1.64809 14.8148 1.06172V1.06172C15.4012 0.475348 16.3519 0.475348 16.9383 1.06172L24 8.12344L16.9383 15.1852C16.3519 15.7715 15.4012 15.7715 14.8148 15.1852V15.1852C14.2285 14.5988 14.2285 13.6481 14.8148 13.0617L18.2531 9.62344H3V22.5Z" fill="#E5271A"/></svg>Útvonalterv</a>
                            </div>
                        </div>
                    `).promise().done(function (e) {
                        $('html, body').animate({ scrollTop: $('.js-map-popup').offset().top - $('header').outerHeight() - 200 }, 200);
                        $('.js-map-popup').addClass('active');
                    });
                }
            });

            google.maps.event.addListener(marker, 'mouseover', function () {
                if (currentmarkerplaces != this && currentmarkerplaces === null) {
                    marker.setIcon(marker.iconActive);
                    $.closeAllInfoWindowPlaces();
                    currentinfowindowplaces = this['infowindow'];
                    currentmarkerplaces = this;
                    removeDefaultInfowindow();

                    $('.js-map-popup-content').html(`
                        <div class="popup__image pb-image-ratio">
                        <img class="img--fluid ofi-cover-center" src=${marker.image_url} alt=${marker.name}>
                        </div>

                        <div class="popup__content">
                            <h2 class="title">
                                ${marker.name}
                            </h2>

                            <div class="popup__content__buttons">
                                <a href="${marker.url}" class="button button--outline button--small-height">
                                Megnézem
                                </a>
                                <a href="https://www.google.com/maps/dir//${marker.address}" target="_blank" class="button button--outline button--small-height"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 22.5C3 23.3284 2.32843 24 1.5 24V24C0.671573 24 0 23.3284 0 22.5V9.62344C0 7.96658 1.34315 6.62344 3 6.62344H18.2531L14.8148 3.18515C14.2285 2.59878 14.2285 1.64809 14.8148 1.06172V1.06172C15.4012 0.475348 16.3519 0.475348 16.9383 1.06172L24 8.12344L16.9383 15.1852C16.3519 15.7715 15.4012 15.7715 14.8148 15.1852V15.1852C14.2285 14.5988 14.2285 13.6481 14.8148 13.0617L18.2531 9.62344H3V22.5Z" fill="#E5271A"/></svg>Útvonalterv</a>
                            </div>
                        </div>
                    `).promise().done(function (e) {
                        $('html, body').animate({ scrollTop: $('.js-map-popup').offset().top - $('header').outerHeight() - 200 }, 200);
                        $('.js-map-popup').addClass('active');
                    });
                }
            });
        }
    }

    $.closeAllInfoWindowPlaces = function closeAllInfoWindowPlaces() {
        $('.js-map-popup').removeClass('active');

        if (currentinfowindowplaces) {
            currentinfowindowplaces.close();
            currentinfowindowplaces = null;
        }
        if (currentmarkerplaces) {
            currentmarkerplaces.setIcon(currentmarkerplaces.iconDefafult);
            currentmarkerplaces = null;
        }
    }

    $(document).on('click', '.js-close-infowindow', function (e) {
        e.preventDefault();
        $.closeAllInfoWindowPlaces();
    });

    $('.js-close-map-popup').on('click', function (e) {
        e.preventDefault();
        $.closeAllInfoWindowPlaces();
    });

    $.center_filter_map_places = function center_filter_map_places(map) {
        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(11);

            let marker = map.markers[0];

            $.closeAllInfoWindowPlaces();
            currentinfowindowplaces = marker['infowindow'];
            currentmarkerplaces = marker;
            map.setCenter(marker.getPosition());
            removeDefaultInfowindow();

            $('.js-map-popup-content').html(`
                <div class="popup__image pb-image-ratio">
                <img class="img--fluid ofi-cover-center" src=${marker.image_url} alt=${marker.name}>
                </div>

                <div class="popup__content">
                    <h2 class="title">
                        ${marker.name}
                    </h2>

                    <div class="popup__content__buttons">
                        <a href="${marker.url}" class="button button--outline button--small-height">
                        Megnézem
                        </a>
                        <a href="https://www.google.com/maps/dir//${marker.address}" target="_blank" class="button button--outline button--small-height"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 22.5C3 23.3284 2.32843 24 1.5 24V24C0.671573 24 0 23.3284 0 22.5V9.62344C0 7.96658 1.34315 6.62344 3 6.62344H18.2531L14.8148 3.18515C14.2285 2.59878 14.2285 1.64809 14.8148 1.06172V1.06172C15.4012 0.475348 16.3519 0.475348 16.9383 1.06172L24 8.12344L16.9383 15.1852C16.3519 15.7715 15.4012 15.7715 14.8148 15.1852V15.1852C14.2285 14.5988 14.2285 13.6481 14.8148 13.0617L18.2531 9.62344H3V22.5Z" fill="#E5271A"/></svg>Útvonalterv</a>
                    </div>
                </div>
            `).promise().done(function (e) {
                $('.js-map-popup').addClass('active');
            });
        } else {
            // fit to bounds
            map.setZoom(11);
            map.fitBounds(bounds);
        }
    }

    // Removing default infoWindow styles
    function removeDefaultInfowindow() {
        $('.gm-style-iw').next().css({ 'height': '0px' }); // remove arrow bottom info window
        $('.gm-style-iw').prev().html(''); // remove style default info windows
        $('.gm-style-iw').parent().css('pointer-events', 'none');
    }

    // Function to draw or update the circle
    function drawSearchCircle(map, searchLat, searchLng, searchRadius) {
        if (searchCircle) {
            // If circle already exists, just update its position and radius
            searchCircle.setCenter(new google.maps.LatLng(searchLat, searchLng));
            searchCircle.setRadius(searchRadius * 1000); // Radius in meters
        } else {
            // Create a new circle
            searchCircle = new google.maps.Circle({
                strokeColor: "#FF0000",
                strokeOpacity: 0.0,
                strokeWeight: 2,
                fillColor: "#e5271a",
                fillOpacity: 0.2,
                map: map,
                center: new google.maps.LatLng(searchLat, searchLng),
                radius: searchRadius * 1000 // Radius in meters
            });
        }
    }

    $.filterMarkerPlaces = function filterMarkerPlaces(selectedCategory, searchTerm, searchLat, searchLng, searchRadius) {
        var filterAbleMarkers = $.filtermapplaces.markers;
        $.closeAllInfoWindowPlaces();
        var visiblePinCounter = 0;
        $.markerClusterPlaces.clearMarkers();

        filterAbleMarkers.forEach(marker => {
            const name = marker.name;
            const address = marker.address;
            const markerLat = marker.position.lat();
            const markerLng = marker.position.lng();

            if (searchTerm.length) {
                const normalizedName = $.normalizeString(name);
                const normalizedAddress = address ? $.normalizeString(address) : '';

                if (!normalizedName.includes(searchTerm) && !normalizedAddress.includes(searchTerm)) {
                    marker.setVisible(false);
                    return;
                }
            }

            const type = String(marker.category).split(',');
            if (selectedCategory !== 'all' && !type.includes(String(selectedCategory))) {
                marker.setVisible(false);
                return;
            }

            if (searchLat !== '' && searchLng !== '' && !isNaN(searchLat) && !isNaN(searchLng)) {
                const distance = $.calculateDistance(searchLat, searchLng, markerLat, markerLng);
                if (distance > searchRadius) {
                    marker.setVisible(false);
                    return;
                }
            }

            marker.setVisible(true);
            $.markerClusterPlaces.addMarker(marker);
            visiblePinCounter++;
        });

        if (visiblePinCounter > 0) {
            $.center_filter_map_places($.filtermapplaces);
            $.markerClusterPlaces.repaint();
        }

        // Draw or update the search circle
        if (searchLat !== '' && searchLng !== '' && !isNaN(searchLat) && !isNaN(searchLng)) {
            drawSearchCircle($.filtermapplaces, searchLat, searchLng, searchRadius);
        } else {
            // Remove the circle if searchLat and searchLng are empty
            if (searchCircle) {
                searchCircle.setMap(null);
                searchCircle = null;
            }
        }
    };

    $.filtermapplaces = null;
    var currentinfowindowplaces = null;
    var currentmarkerplaces = null;
    $.markerClusterPlaces;

    $(function () {
        $('.js-filter-map-places').each(function () {
            // create map
            $.filtermapplaces = new_filter_map_places($(this));
        });
    });

})(jQuery);
